export default "__VITE_ASSET__xkCCaCuQ__"